import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { AuthorizationExpiredFilter } from 'src/app/shared/models/authorizationexpiredFilter.model';
import { WaiverRequestFilter } from 'src/app/shared/models/waiverrequestFilter.model';
import { AuthorizationExpiredService } from 'src/app/shared/services/core/authorization-expired.service';

@Component({
  selector: 'app-aut-vencidas',
  imports: [TegelModule, CommonModule],
  templateUrl: './aut-vencidas.component.html',
  styleUrl: './aut-vencidas.component.scss'
})
export class AutVencidasComponent implements OnInit {
  request: any[];
  reactivates: any[];
  requestFilter: AuthorizationExpiredFilter;
  page = 1;
  total!: number;
  reverse: boolean = false;
  order = "ID";

  constructor(
    private dialogService: DialogService,
    private utilService: UtilService,
    private authorizationExpiredService: AuthorizationExpiredService,
    private toastrService: ToastrService
  )  {
    this.requestFilter = new WaiverRequestFilter();
    this.reactivates = this.request = [];
  }

  ngOnInit(): void { }

  change(ev: any, val: any){
    if (ev.target.checked) {
      this.reactivates.push(val);
    } else {
      let i = this.reactivates.indexOf(val);
      this.reactivates.splice(i, 1);
    }
  }

  // chooseClient() {
  //   this.dialogService.addDialog(ClientComponent, {}, this.utilService.getModalOptions()).subscribe((result) => {
  //     if (result && result.client != null) {
  //       const client = result.client;
  //       this.requestFilter.clientId = client.id;
  //       this.requestFilter.corporateName = client.corporateName;
  //     }
  //   });
  // }

  getAll(page: number){
    this.reactivates = [];

    this.authorizationExpiredService.get(page, this.order, this.utilService.getOrderType(this.reverse), this.requestFilter).subscribe((result) => {
      this.request = result.page;
      this.page = result.currentPage;
      this.total = result.totalRecords;
    });
  }

  reactivate() {
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja reativar a(s) solicitação(ões) [ ' + this.reactivates.toString() + ' ]?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed){
        this.sendReactivated();
      }
    });
  }

  report() {
    this.authorizationExpiredService.report(this.requestFilter);
  }

  sendReactivated(){
    this.authorizationExpiredService.reactivate(this.reactivates).subscribe((result) => {
      if (result && !result.hasErrors){
        this.reactivates.forEach(id => {
          const index = this.request.findIndex(data => data.id === id);
          this.request.splice(index, 1);
        });

        this.reactivates = [];
        this.toastrService.success("Todas as requisições foram reativadas", "Sucesso");
      }
    });
  }

  resetFilters(form: NgForm){
    this.requestFilter = new WaiverRequestFilter();
    form.resetForm(this.requestFilter);
  }

  search(){
    this.getAll(1);
  }


}
